import createReactComponent from '../createReactComponent';
export default createReactComponent('flag-2', 'IconFlag2', [
  ['path', { d: 'M5 14h14v-9h-14v16', key: 'svg-0' }],
]);
